export enum TemplatesQueries {
  GET_ASPECT_RATIOS = `
    query AspectRatios {
        aspectRatios(
        
        where: { active: { eq: true } }) {
            nodes {
                id
                code
                description
            }
        }
    }
    `,
  GET_MEDIA_FORMATS = `
    query MediaFormats {
        mediaFormats(
        
        where: { active: { eq: true } }) {
            nodes {
                id
                code
                description
            }
        }
    }
    `,
  GET_SHOT_TYPES = `
    query ShotTypes {
        shotTypes(  order: {code: ASC}){
            nodes {
                id
                code
                name
                orderTypeShotTypeConfigurations {
                    orderTypeId
                }
                    
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
    `,
  GET_SHOT_TYPE_LIST = `
    query ShotTypes($where: ShotTypeFilterInput, $first: Int, $after: String) {
        shotTypes(where: $where, first: $first, after: $after, order: { name: ASC }) {
            totalCount
            nodes {
                id
                code
                name
                isInUse
                orderTypeId
            }
        }
    }
    `,

  GET_LEGACY_SHOT_TYPE_CODES = `
    query LegacyShotTypeCodes {
        exportCodifiedUseMaps(
            where: { active: { eq: true }, exportChannel: { code: { eq: "LEGACY" } } },
            first: 50,
            order: { isDefault: DESC }
        ) {
            nodes {
                shots {
                    shotTypeId
                    code
                    active
                }
            }
        }
    }
    `,
  GET_FREE_LEGACY_CODES_FOR_SHOT_TYPE = `
    query FreeLegacyCodesForShotType {
        freeLegacyCodesForShotType {
            code
            description
        }
    }
    `,
  GET_SHOT_COMBINATIONS = `
    query ShotCombinations( $mediaFormatId: Int!, $aspectRatioId: Int!) {
        shotCombinations(
            
            where: { active: { eq: true }, mediaFormatId: { eq: $mediaFormatId }, aspectRatioId: { eq: $aspectRatioId } }
        ) {
            nodes {
                id
                mediaFormatId
                aspectRatioId
                active
            }
        }
    }
    `,

  GET_TEMPLATES = `
    query Templates($where: TemplateDtiFilterInput, $first: Int, $after: String) {
        templates(
            where: $where,
            first: $first,
            after: $after
        ) {
            nodes {
                templateId
                templateName
                hasSizeGroup
                isDefault

                shotTypes {
                    templateId
                    sizeGroupId
                    sizeGroupName
                    ord
                    shotType {
                        id
                        label
                    }
                    aspectRatio {
                        id
                        label
                    }
                    mediaFormat {
                        id
                        label
                    }
                     
                }
                styles {
                    templateId
                    modelId
                    styleCode
                    styleName
                    fullName
                    sketchImgPath
                }
                colors {
                    id
                    code
                    finalColorName
                }
                category {
                    id
                    label
                }
                brand {
                    id
                    label
                }
                collection {
                    id
                    label
                }
                gender {
                    id
                    label
                }
                styleGroup {
                    id
                    label
                }

            }
            totalCount
        }
    }
    `,

  GET_LEGACY_IMAGE_FORMATS = `
    query LegacyImageFormats {
        legacyImageFormats {
            id
            code
            description
            width
            height
            active
            ord
            updateDate
        }
    }
    `,
  GET_EXPORT_CHANNELS = `
    query ExportChannels($where: ExportChannelFilterInput) {
        exportChannels(where: $where) {
            totalCount
            nodes {
                id
                code
                name
                usesCodifiedUses
            }
        }
    }
    `,

  GET_EXPORT_CODES = `
    query ExportCodes {
        exportCodes(where: { codifiedUseId: { neq: null } }) {
            totalCount
            nodes {
                id
                code
                description
                active
                codifiedUse {
                    id
                    code
                    description
                    active
                }
            }
        }
    }
    `,

  GET_EXPORT_TEMPLATES = `
    query ExportCodifiedUseMaps($where: ExportCodifiedUseMapFilterInput, $first: Int, $after: String) {
        exportCodifiedUseMaps(
            where: $where,
            first: $first,
            after: $after,
            order: { isDefault: DESC }
        ) {
            totalCount
            nodes {
                id
                categoryId
                isDefault
                active
                creationUserId
                creationDate
                updateUserId
                updateDate
                company {
                    id
                    name
                    active
                    cancelled
                    isIntercompany
                    customerCodeAs400
                    vatNumber
                    companyForm
                    paymentCode
                    street
                    zipCode
                    city
                    province
                    countryIsoCode3
                    billingLocationId
                }
                brand {
                    id
                    code
                    name
                    cancelled
                    active
                }
                category {
                    id
                    name
                    cancelled
                    active
                    shortName
                }
                collection {
                    id
                    name
                    startDate
                    endDate
                    companyId
                }
                styleGroup {
                    id
                    name
                    active
                    cancelled
                }
                gender {
                    id
                    code
                    name
                    cancelled
                    active
                }
                exportChannel {
                    id
                    code
                    name
                    usesCodifiedUses
                }
                shots {
                    id
                    active
                    creationUserId
                    creationDate
                    updateUserId
                    updateDate
                    shotType {
                        id
                        code
                        name
                    }
                    aspectRatio {
                        id
                        code
                        description
                        active
                    }
                    mediaFormat {
                        id
                        code
                        description
                        active
                    }
                    exportCodifiedUseMapId
                    code
                }
            }
        }
    }
    `
}
